var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus["NONE"] = "NONE";
    ActivityStatus["EXPIRED"] = "EXPIRED";
    ActivityStatus["RECENT"] = "RECENT";
})(ActivityStatus || (ActivityStatus = {}));
export default ActivityStatus;
